<template>
  <signin v-if="isLoginOpen" @close="onCloseSignin" @signup="isLoginOpen = false; isSignupOpen = true" />
  <TMmodal v-if="TMOpen" :isOpen="TMOpen" type="header" @close="TMOpen = false" />
  <join v-if="isSignupOpen" @close="onCloseSignup" />
  <join-complete v-if="isSignupCompleteOpen" @close="isSignupCompleteOpen = false; isLoginOpen = true" />
  <new-message v-if="isUnReadMessage" />

  <aside id="kc-sidebar" class="kc-sidebar" :class="{'is-open': sidebarOpen || sidebarHovered}" :aria-label="$t('front.kcasino.mainMenu')" @mouseenter="hoverSidebar" @mouseleave="sidebarHovered = false" @focusin="focusSidebar" @keydown.esc="sidebarOpen = false; sidebarHovered = false; $event.target.blur()">
    <button class="kc-brand" :aria-label="'KCASINO ' + $t('front.kcasino.home')" @click="selectMenu({category: ''})">
      <img class="kc-brand-mark" :src="assets.emblem" alt="KCASINO" />
      <img class="kc-brand-full" :src="assets.logo" alt="KCASINO" />
    </button>
    <nav class="kc-sidebar-scroll">
      <button class="kc-sidebar-toggle" aria-controls="kc-sidebar" :aria-label="$t('front.kcasino.toggleMenu')" :aria-expanded="sidebarOpen || sidebarHovered" @click="toggleSidebar"><img src="/kcasino/menu.svg" alt="" /><span class="kc-menu-label">{{ $t('front.kcasino.toggleMenu') }}</span></button>
      <ul v-for="(group, groupIndex) in menuGroups" :key="groupIndex" class="kc-menu-group">
        <li v-for="item in group" :key="item.label">
          <button :aria-label="$t(item.label)" :title="$t(item.label)" :class="{active: isActive(item)}" @click="selectMenu(item)">
            <i class="kc-icon" :class="item.icon" aria-hidden="true">{{ item.glyph }}</i>
            <span class="kc-menu-label">{{ $t(item.label) }}<em v-if="item.page === 'message'"> ({{ unReadMessageCount || 0 }})</em></span>
          </button>
        </li>
      </ul>
      <div class="kc-mobile-sidebar-account">
        <button v-if="userData" @click="sidebarOpen = false; sidebarHovered = false; signOut()">{{ $t('front.common.logout') }}</button>
        <button :aria-pressed="$i18n.locale === 'ko'" @click="changeLocale('ko')">한국어</button>
        <button :aria-pressed="$i18n.locale === 'en'" @click="changeLocale('en')">English</button>
      </div>
    </nav>
  </aside>
  <button v-if="sidebarOpen || sidebarHovered" class="kc-mobile-menu-dismiss" :aria-label="$t('front.main.close')" @click="toggleSidebar" />

  <header class="kc-topbar" :class="{'is-member': !!userData}" @keydown.esc.prevent="sidebarOpen = false; sidebarHovered = false">
    <div class="kc-mobile-tools">
      <button class="kc-mobile-menu-toggle" aria-controls="kc-sidebar" :aria-label="$t('front.kcasino.toggleMenu')" :aria-expanded="sidebarOpen || sidebarHovered" @click="toggleSidebar"><i class="kc-mobile-glyph" aria-hidden="true">&#xe93a;</i></button>
    </div>
    <button class="kc-mobile-brand" :aria-label="'KCASINO ' + $t('front.kcasino.home')" @click="selectMenu({category: ''})"><img src="/kcasino/logo.XkEsiZSD.svg" alt="KCASINO" /></button>
    <div class="kc-notice"><img :src="noticeIcon" alt="" /><div><span>{{ $t('front.header.msg') }}</span></div></div>
    <div v-if="userData" class="kc-member">
      <div class="kc-wallet">
        <button :aria-label="$t('front.kcasino.balanceMenu')" :aria-expanded="showMenuMoney" @click="showMenuMoney = !showMenuMoney"><i class="kc-icon">&#xe938;</i><img class="kc-mobile-won" src="/kcasino/mobile-won.svg" alt="" /><span class="kc-currency-label">KRW</span> <b>₩ {{ thousand(userData.cashAmt || 0) }}</b></button>
        <button :aria-label="$t('front.kcasino.refreshBalance')" @click="$store.dispatch('storeUserCoinAmt')"><span class="kc-desktop-refresh">⟳</span><img class="kc-mobile-refresh" src="/kcasino/mobile-refresh.svg" alt="" /></button>
        <button @click="goKcasinoPage('point')"><span class="kc-point-icon">P</span>{{ thousand(userData.pointAmt || 0) }}</button>
        <button class="kc-convert" @click="onClickTM">{{ $t('front.kcasino.convert') }}</button>
        <button class="kc-mobile-wallet-toggle" :aria-label="$t('front.kcasino.balanceMenu')" :aria-expanded="showMenuMoney" @click="showMenuMoney = !showMenuMoney"><img src="/kcasino/mobile-select-arrow.svg" alt="" /></button>
        <div v-if="showMenuMoney" class="kc-wallet-menu"><button @click="goKcasinoPage('charge')">{{ $t('front.common.deposit') }}</button><button @click="goKcasinoPage('exchange')">{{ $t('front.common.withdrawal') }}</button><button @click="goKcasinoPage('point')">{{ $t('front.kcasino.pointHistory') }}</button></div>
      </div>
      <span class="kc-member-grade">{{ $t('front.kcasino.regular') }}</span>
      <button class="kc-member-name" @click="goKcasinoPage('info')">{{ userData.memNick || userData.memId }}</button>
      <button class="kc-signout" @click="signOut">{{ $t('front.common.logout') }}</button>
    </div>
    <div v-else class="kc-auth">
      <button class="kc-login" @click="showLogin"><i class="kc-icon">&#xe940;</i>{{ $t('front.login.loginButton') }}</button>
      <button class="kc-join" @click="isSignupOpen = true"><i class="kc-icon">&#xe941;</i>{{ $t('front.common.signup') }}</button>
    </div>
  </header>
  <nav class="kc-mobile-bottom-nav" :aria-label="$t('front.kcasino.mainMenu')">
    <button @click="selectMenu({page: 'charge'})"><i class="kc-mobile-glyph" aria-hidden="true">&#xe917;</i>{{ $t('front.common.deposit') }}</button>
    <button @click="selectMenu({page: 'exchange'})"><i class="kc-mobile-glyph" aria-hidden="true">&#xe951;</i>{{ $t('front.common.withdrawal') }}</button>
    <button class="kc-mobile-home" :aria-current="$route.path === '/' && !$route.query.category ? 'page' : undefined" @click="selectMenu({category: ''})"><i class="kc-mobile-glyph" aria-hidden="true">&#xe91e;</i>{{ $t('front.kcasino.home') }}</button>
    <button @click="selectMenu({page: 'event'})"><i class="kc-mobile-glyph" aria-hidden="true">&#xe91a;</i>{{ $t('front.board.event') }}</button>
    <button @click="selectMenu({page: 'qnaList'})"><i class="kc-mobile-glyph" aria-hidden="true">&#xe915;</i>{{ $t('front.common.cscenter') }}</button>
  </nav>
  <button class="kc-chat" :aria-label="$t('front.common.cscenter')" @click="goKcasinoPage('qnaList')"><img src="/kcasino/message-square.svg" alt="" /></button>
</template>

<script>
import { mapState } from 'vuex'
import Join from '@/components/member/Join'
import JoinComplete from '@/components/member/JoinComplete'
import Signin from '@/components/member/Signin'
import TMmodal from '@/components/common/TotalMoney'
import NewMessage from '@/components/member/Message.vue'
import assets from '@/data/kcasino-assets.json'

export default {
  name: 'Header',
  components: { NewMessage, Signin, JoinComplete, Join, TMmodal },
  data () {
    return {
      assets,
      sidebarOpen: false,
      sidebarHovered: false,
      TMOpen: false,
      isLoginOpen: false,
      isSignupOpen: false,
      isSignupCompleteOpen: false,
      showMenuMoney: false,
      menuGroups: [
        [
          { label: 'front.gnb.casino', icon: 'icon-iiconDice', category: 'casino' },
          { label: 'front.gnb.slot', icon: 'icon-iiconSlote', category: 'slot' },
          { label: 'front.gameCategory.sports', icon: 'icon-icconSPORT', sports: 'prematch' },
          { label: 'front.board.event', icon: 'icon-iiconSpeaker', page: 'event' }
        ],
        [
          { label: 'front.common.notices', icon: 'icon-iiconRing', page: 'notice' },
          { label: 'front.common.bettingGuide', icon: 'icon-iiconPolicy', page: 'bettingGuideSport' },
          { label: 'front.mypage.message', icon: 'icon-iiconMail', page: 'message' },
          { label: 'front.common.mypage', icon: 'icon-iiconMember', page: 'info' },
          { label: 'front.common.deposit', glyph: '\ue938', page: 'charge' },
          { label: 'front.common.withdrawal', glyph: '\ue939', page: 'exchange' },
          { label: 'front.mypage.betList', icon: 'icon-iiconListA', page: 'bettingList' },
          { label: 'front.kcasino.pointHistory', icon: 'icon-icconPOINT', page: 'point' },
          { label: 'front.kcasino.balanceHistory', icon: 'icon-iiconListB', page: 'chargeExchangeList' },
          { label: 'front.common.cscenter', icon: 'icon-iiconService', page: 'qnaList' }
        ]
      ]
    }
  },
  computed: {
    ...mapState(['userData', 'unReadMessageCount']),
    noticeIcon () { return '/kcasino/notice.svg' },
    isUnReadMessage () { return Number(this.unReadMessageCount) > 0 && !/message|msg/.test(this.$route.name || '') }
  },
  watch: { $route () { this.sidebarOpen = false; this.sidebarHovered = false; this.showMenuMoney = false } },
  mounted () { this.emitter.on('kcasino-login', this.showLogin) },
  beforeUnmount () { this.emitter.off('kcasino-login', this.showLogin) },
  methods: {
    hoverSidebar () { this.sidebarHovered = window.matchMedia('(hover: hover) and (min-width: 601px)').matches },
    focusSidebar (event) { if (event.target.matches(':focus-visible')) this.sidebarOpen = true },
    toggleSidebar (event) {
      this.sidebarOpen = !(this.sidebarOpen || this.sidebarHovered)
      this.sidebarHovered = false
      if (!this.sidebarOpen) event.currentTarget.blur()
    },
    showLogin () { this.isLoginOpen = true; this.isSignupOpen = false },
    isActive (item) {
      return item.sports
        ? this.$route.name === 'embeddedSports'
        : item.category !== undefined && this.$route.path === '/' && (this.$route.query.category || '') === item.category
    },
    selectMenu (item) {
      this.sidebarOpen = false
      this.sidebarHovered = false
      if (item.sports) this.goKcasinoPage('embeddedSports', { mode: item.sports })
      else if (item.category !== undefined) this.goKcasinoLobby(item.category)
      else this.goKcasinoPage(item.page)
    },
    async onClickTM () { if (await this.onConfirm('front.kcasino.confirmTransfer')) this.TMOpen = true },
    onCloseSignin (value) { this.isLoginOpen = false; if (value === 'join') this.isSignupOpen = true },
    onCloseSignup (status) { this.isSignupOpen = false; if (status) this.isSignupCompleteOpen = true }
  }
}
</script>
